// utils/rolePermissions/features.ts - utils/rolePermissions.ts split (sub-module features)




export const ALL_FEATURES = [
  // Data Export & Import
  { id: 'export_csv', name: 'Export CSV', category: 'feature', description: 'Dapat export data ke CSV' },
  { id: 'import_data', name: 'Impor Data', category: 'feature', description: 'Dapat impor data (termasuk upload resi massal)' },

  // Product Management
  { id: 'edit_product', name: 'Edit Produk', category: 'feature', description: 'Dapat membuat dan edit produk' },
  { id: 'delete_product', name: 'Hapus Produk', category: 'feature', description: 'Dapat menghapus produk' },
  { id: 'edit_form', name: 'Edit Formulir', category: 'feature', description: 'Dapat membuat dan edit formulir' },
  { id: 'delete_form', name: 'Hapus Formulir', category: 'feature', description: 'Dapat menghapus formulir' },
  { id: 'edit_landing_page', name: 'Edit Landing Page', category: 'feature', description: 'Dapat membuat dan edit landing page' },

  // Order Management
  { id: 'delete_order', name: 'Hapus Pesanan', category: 'feature', description: 'Dapat menghapus pesanan' },
  { id: 'change_order_status', name: 'Ubah Status Pesanan', category: 'feature', description: 'Dapat mengubah status pesanan' },
  { id: 'manual_order_creation', name: 'Buat Pesanan Manual', category: 'feature', description: 'Dapat membuat pesanan secara manual' },
  { id: 'assign_order_cs', name: 'Assign CS Pesanan', category: 'feature', description: 'Dapat menugaskan/mengganti CS pesanan (khusus Admin)' },

  // Financial
  { id: 'view_earnings', name: 'Lihat Penghasilan', category: 'feature', description: 'Dapat melihat penghasilan' },
  { id: 'view_cost_margin', name: 'Lihat Modal & Margin', category: 'feature', description: 'Dapat melihat harga modal, GMV, dan CM1 per pesanan' },

  // User & Role Management
  { id: 'manage_users', name: 'Kelola Pengguna', category: 'feature', description: 'Dapat mengelola akun pengguna' },
  { id: 'manage_roles', name: 'Kelola Peran', category: 'feature', description: 'Dapat mengelola role dan izin' },

  // Reports
  { id: 'view_reports', name: 'Lihat Laporan', category: 'feature', description: 'Dapat melihat semua laporan' },

  // Settings
  { id: 'edit_settings', name: 'Edit Pengaturan', category: 'feature', description: 'Dapat mengedit pengaturan sistem' },
  { id: 'manage_tracking', name: 'Kelola Pelacakan', category: 'feature', description: 'Dapat mengelola pixel tracking' },

  // Dashboard Widgets
  { id: 'view_sales_stats', name: 'Lihat Statistik Penjualan', category: 'feature', description: 'Dapat melihat statistik penjualan di dashboard' },
  { id: 'view_charts', name: 'Lihat Grafik', category: 'feature', description: 'Dapat melihat grafik penjualan dan pesanan' },
  { id: 'view_top_products', name: 'Lihat Top Produk', category: 'feature', description: 'Dapat melihat ranking produk terlaris' },
  { id: 'view_top_advertisers', name: 'Lihat Top Advertiser', category: 'feature', description: 'Dapat melihat ranking advertiser terbaik' },
  { id: 'view_top_cs', name: 'Lihat Top CS', category: 'feature', description: 'Dapat melihat ranking CS terbaik' },
  { id: 'view_recent_orders', name: 'Lihat Pesanan Terbaru', category: 'feature', description: 'Dapat melihat pesanan terbaru di dashboard' },

  // WhatsApp Management
  { id: 'manage_whatsapp', name: 'Kelola WhatsApp', category: 'feature', description: 'Dapat mengelola nomor WhatsApp dan automation' },
  { id: 'view_whatsapp_logs', name: 'Lihat Log WhatsApp', category: 'feature', description: 'Dapat melihat log aktivitas WhatsApp' },
  { id: 'whatsapp_automation', name: 'Automasi WhatsApp', category: 'feature', description: 'Dapat mengaktifkan automasi pesan WhatsApp' },

  // System
  { id: 'manage_error_logs', name: 'Kelola Log Error', category: 'feature', description: 'Dapat melihat dan mengelola log error' },
  { id: 'view_performance', name: 'Lihat Performa', category: 'feature', description: 'Dapat melihat dashboard performa sistem' },

  // Prospek Chat & Automation
  { id: 'manage_prospek_followup', name: 'Kelola Follow-up Prospek', category: 'feature', description: 'Dapat mengirim follow-up manual di Prospek Chat' },
  { id: 'manage_prospek_checkout', name: 'Buat Pesanan dari Prospek', category: 'feature', description: 'Dapat konversi prospek ke pesanan (CO manual) dan edit jumlah' },
  { id: 'manage_ads_automation', name: 'Kelola Iklan & Automasi', category: 'feature', description: 'Dapat mengelola automation pembuatan iklan Meta' },
] as const;
